const CHUNK_RECOVERY_KEY = "alphasignal_chunk_recovery_attempted";

export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return (
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("Importing a module script failed") ||
    message.includes("Loading chunk") ||
    message.includes("ChunkLoadError")
  );
}

export function recoverFromChunkLoadError(error: unknown): boolean {
  if (!isChunkLoadError(error) || typeof window === "undefined") return false;

  try {
    if (window.sessionStorage.getItem(CHUNK_RECOVERY_KEY) === "true") {
      return false;
    }
    window.sessionStorage.setItem(CHUNK_RECOVERY_KEY, "true");
  } catch {
    // Continue with the hard navigation even if sessionStorage is unavailable.
  }

  const url = new URL(window.location.href);
  url.searchParams.set("__chunk_reload", Date.now().toString());
  window.location.replace(url.toString());
  return true;
}
